<template>
    <div class="results-summary">
        <div
            class="results-summary__item"
            v-for="(outcome, index) in quiz_data.outcomes"
            :key="index">

            <img
                class="results-summary__image"
                :src=getImgUrl(outcome.cropped_image_url)
            >

            <h2 class="outline yellow results-summary__stat" v-html="Math.round(outcome_stats[index])+'%'" v-if="outcome_stats[index]"></h2>
            <h2 class="outline yellow results-summary__stat" v-else>0%</h2>

            <h4 v-html="outcome.title"></h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "ResultsSummary",
    props: {
        quiz_data: Object
    },
    data() {
        return {
            'outcomes': null,
            'outcome_stats': {},
            'updateInterval': null
        };
    },
    created() {
        this.updateResults();
        this.updateInterval = setInterval(this.updateResults, 2000)
    },
    destroyed() {
        clearInterval(this.updateInterval);
    },
    methods: {
        updateResults() {

            fetch('/api/submissions/summary', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then((response) => {
                    this.outcome_stats = response;
                });
        }
    },

}
</script>

<style scoped lang="stylus">
.results-summary {
    display: flex;
    flex-wrap: wrap;
    align-items center;
    justify-content center;
    gap: 1.5em;
    margin-bottom: 4em;

    &__image {
        object-fit: cover;
        width: 10em;
        height: 10em;
        display: block;
        border-radius 50%;
        margin-bottom: 1em;
        image-rendering: -webkit-optimize-contrast;
    }

    &__stat {
        margin-bottom: 0.2em;
    }
}
</style>